/**
 * typeVisuals — one icon + coastal tint per service type, shared by every
 * services surface (guest panel, catalog, runs board, today board) so a
 * transfer looks like the same transfer everywhere.
 */

import {
  Bus, UtensilsCrossed, Backpack, Flower2, Clock, Sparkles, Umbrella, Waves,
  type LucideIcon,
} from 'lucide-react';
import type { ServiceType } from '../types';

export interface TypeVisual {
  icon: LucideIcon;
  /** Tinted tile (soft bg + ink text) — list rows, small chips. */
  tile: string;
  /** Solid tile (fill bg + white text) — hero/drawer icons. */
  solid: string;
}

export const TYPE_VISUALS: Record<ServiceType | 'activity', TypeVisual> = {
  activity: { icon: Waves, tile: 'bg-ocean-100 text-ocean-800', solid: 'bg-ocean-600 text-white' },
  transfer: { icon: Bus, tile: 'bg-coral-100 text-coral-800', solid: 'bg-coral-600 text-white' },
  beach_transfer: { icon: Umbrella, tile: 'bg-sage-100 text-sage-800', solid: 'bg-sage-600 text-white' },
  fnb: { icon: UtensilsCrossed, tile: 'bg-sun-100 text-sun-800', solid: 'bg-sun-600 text-white' },
  rental: { icon: Backpack, tile: 'bg-ocean-100 text-ocean-800', solid: 'bg-ocean-600 text-white' },
  wellness: { icon: Flower2, tile: 'bg-violet-100 text-violet-800', solid: 'bg-violet-600 text-white' },
  extra: { icon: Clock, tile: 'bg-violet-100 text-violet-800', solid: 'bg-violet-600 text-white' },
  other: { icon: Sparkles, tile: 'bg-sand-100 text-sand-700', solid: 'bg-sand-500 text-white' },
};

export function typeVisual(type?: ServiceType | 'activity' | null): TypeVisual {
  return TYPE_VISUALS[type ?? 'other'] ?? TYPE_VISUALS.other;
}

/** Booking-mode chip tints (catalog tag line). */
export const MODE_TINT: Record<string, string> = {
  one_off: 'bg-sand-100 text-sand-700',
  on_request: 'bg-coral-100 text-coral-800',
  scheduled: 'bg-ocean-100 text-ocean-800',
  recurring: 'bg-sage-100 text-sage-800',
  per_night: 'bg-sun-100 text-sun-800',
  rental: 'bg-violet-100 text-violet-800',
};
